export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  anexo: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/expenseType/components/add/expenseType-form.js